// extracted by mini-css-extract-plugin
export default {"sideNavi":"SideNevigation_sideNavi__VqIaB","icon":"SideNevigation_icon__130Es","title":"SideNevigation_title__bBtK3"};